exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3gbd86EBQA2qhwr4uZTIaG {\n  position: relative;\n  display: block;\n}\n", ""]);
// Exports
exports.locals = {
	"ic-tag-picker": "_3gbd86EBQA2qhwr4uZTIaG"
};